import React, { useState } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { IsVideoOrImg } from 'views/rebranded-module/common/components/UI/IsVideoOrImg';
import StylesBox from 'views/rebranded-module/common/components/UI/GridsGallery/GridsGallery.styles';
import { RiImageLine } from 'react-icons/ri';
import { GalleryDialog } from 'views/rebranded-module/common/components/UI/GalleryDialog/GalleryDialog';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const GridsGallery = (props) => {
  const { mediaItems, content: propsContent } = props;
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const gridGalleryContentFromUseContent = useContent('GalleryComponent');
  const content = gridGalleryContentFromUseContent || propsContent;
  return (
    <StylesBox>
      <Box className="GGGRidWrapper">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={mediaItems.length > 1 ? 6 : 12}
            className="GGGRid">
            <IsVideoOrImg slide={mediaItems[0]} />
          </Grid>

          {mediaItems.length > 1 && (
            <Grid
              item
              xs={6}
              md={6}
              className="GGGRid GGGRidShowTabletAndDesktop showTabletAndDesktop">
              <IsVideoOrImg slide={mediaItems[1]} />
              <IsVideoOrImg slide={mediaItems[2]} />
            </Grid>
          )}
        </Grid>
        <Box className="showTabletAndDesktop">
          {mediaItems.length > 3 && (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              className="GGShowAll "
              startIcon={<RiImageLine />}
              onClick={() => setOpen(true)}>
              {content.showAllMedia}
            </Button>
          )}
        </Box>
        <Box className="showMOBILE">
          {mediaItems.length > 1 && (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              className=" GGShowAll "
              startIcon={<RiImageLine />}
              onClick={() => setOpen(true)}>
              {content.showAllMedia}
            </Button>
          )}
        </Box>
      </Box>

      <GalleryDialog
        open={open}
        onClose={() => setOpen(false)}
        mediaItems={mediaItems}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
    </StylesBox>
  );
};

export { GridsGallery };
